<app-leveltwo [videos]="true" [pageName]="'Marine and Aircraft'">

<div heading="General Info" class="General">
  <h3>{{'MarineAircraft.PageTitle'|translate}}</h3>

      <!--<h4>{{'MarineAircraft.Boats'|translate}}</h4>-->
      <p>{{'MarineAircraft.Boatstext1'|translate}}</p>
      <p>{{'MarineAircraft.Boatstext2'|translate}}</p>
      <p>{{'MarineAircraft.Boatstext3'|translate}}</p>
      <p>{{'MarineAircraft.Boatstext4'|translate}}</p>
      <h4>{{'MarineAircraft.Taxes'|translate}}</h4>
      <p>{{'MarineAircraft.Taxestext1'|translate}}</p>

      <b>{{'MarineAircraft.Taxestext2'|translate}}</b><br>
      <ul>
        <li>{{'MarineAircraft.Taxeslistitem1'|translate}}</li>
        <li>{{'MarineAircraft.Taxeslistitem2'|translate}}</li>
        <li>{{'MarineAircraft.Taxeslistitem3'|translate}}</li>
      </ul>
      <h4>{{'MarineAircraft.Publication'|translate}}</h4>
      <p>{{'MarineAircraft.Publicationtext1'|translate}}</p>
      <!--
      <p>{{'MarineAircraft.Publicationtext2'|translate}}</p>
      -->
      <a href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1625768915/Handbooks/ASSESSMENT_OF_VESSELS.pdf" type="button" class="btn btn-primary" target="_blank">{{'MarineAircraft.button2'|translate}}</a><br><br>
      <a href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1625768917/Handbooks/ASSESSMENT_OF_GENERAL_AIRCRAFT.pdf" type="button" class="btn btn-primary" target="_blank">{{'MarineAircraft.button1'|translate}}</a>
  <!--<tabset #staticTabs>
    <tab heading="General Info" class="General">
      <h3>{{'MarineAircraft.PageTitle'|translate}}</h3>
      <h4>{{'MarineAircraft.Pagesubtitle'|translate}}</h4>
      <h5>{{'MarineAircraft.Boats'|translate}}</h5>
      <p>{{'MarineAircraft.Boatstext1'|translate}}</p>
      <p>{{'MarineAircraft.Boatstext2'|translate}}</p>
      <p>{{'MarineAircraft.Boatstext3'|translate}}</p>
      <p>{{'MarineAircraft.Boatstext4'|translate}}</p>
      <h5>{{'MarineAircraft.Taxes'|translate}}</h5>
      <p>{{'MarineAircraft.Taxestext1'|translate}}</p>
      <p>{{'MarineAircraft.Taxestext2'|translate}}</p>
      <p>{{'MarineAircraft.Taxestext3'|translate}}</p>
      <h5>{{'MarineAircraft.Publication'|translate}}</h5>
      <p>{{'MarineAircraft.Publicationtext1'|translate}}</p>
      <p>{{'MarineAircraft.Publicationtext2'|translate}}</p>


    </tab>
    <tab heading="FAQ">FAQ</tab>
    <tab heading="Forms">Forms</tab>

  </tabset>-->

</div>
  <app-videos-grid class="Videos" [videos]="videos"></app-videos-grid>
</app-leveltwo>
